import { render, staticRenderFns } from "./EditStockData.vue?vue&type=template&id=5ca49b2f&scoped=true&"
import script from "./EditStockData.vue?vue&type=script&lang=js&"
export * from "./EditStockData.vue?vue&type=script&lang=js&"
import style0 from "./EditStockData.vue?vue&type=style&index=0&id=5ca49b2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca49b2f",
  null
  
)

export default component.exports